import React from "react";
import { DialogTitle } from "@mui/material";
import { BootstrapDialog } from "components/languageTiers/AddLanguageTiers";
import { useTranslation } from "react-i18next";
import { Building2, Globe } from "lucide-react";

function ChangeClientLanguageModal({ isOpen, onClose, onSelectMode }) {
  const { t } = useTranslation();

  return (
    <BootstrapDialog
      fullWidth={true}
      maxWidth="sm"
      open={isOpen}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      aria-labelledby="change-client-language-dialog-title"
      sx={{
        "& .MuiDialog-container": {
          alignItems: "center",
        },
        "& .MuiPaper-root": {
          overflowY: "visible",
          margin: "auto",
          borderRadius: "16px",
          maxWidth: "580px",
        },
      }}
    >
      <div className="modal-content full_modal">
        <DialogTitle sx={{ p: 0 }}>
          <div
            className="modal-header header_modal d-flex justify-content-between align-items-center"
            style={{ padding: "20px 25px 15px", borderBottom: "1px solid #dee2e6" }}
          >
            <h5 className="modal-title_u mb-0">
              {t("appointmentView.changeClientOrLanguage", "Change Client or Language")}
            </h5>
            <button
              onClick={onClose}
              type="button"
              className="btn-close"
              aria-label="Close"
              style={{
                background: "none",
                border: "none",
                fontSize: "1.3rem",
                cursor: "pointer",
                padding: 0,
                margin: 0,
                color: "#6c757d",
                lineHeight: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>
          </div>
        </DialogTitle>
        <div className="modal-body modal_form_body" style={{ padding: "20px 25px" }}>
          <p style={{ color: "#666", marginBottom: "20px", fontSize: "0.95rem" }}>
            {t(
              "appointmentView.changeClientLanguageDesc",
              "Select which detail you need to change. The current appointment details will be copied, allowing you to select a new client or language, and re-create the assignment while cancelling the previous one."
            )}
          </p>

          <div className="d-flex flex-column gap-3">
            {/* Change Client Card */}
            <div
              onClick={() => onSelectMode("client")}
              className="w-100"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                padding: "16px 20px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#7e3af2";
                e.currentTarget.style.backgroundColor = "#f9f5ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e0e0e0";
                e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#efe8ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#7e3af2",
                  flexShrink: 0,
                }}
              >
                <Building2 size={24} />
              </div>
              <div>
                <h4 style={{ margin: "0 0 4px 0", fontSize: "1.05rem", fontWeight: "600", color: "#333" }}>
                  {t("appointmentView.changeClient", "Change Client")}
                </h4>
                <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
                  {t(
                    "appointmentView.changeClientHint",
                    "Select a new client account. Language, date, time, and other appointment details will be preserved."
                  )}
                </p>
              </div>
            </div>

            {/* Change Language Card */}
            <div
              onClick={() => onSelectMode("language")}
              className="w-100"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                padding: "16px 20px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#0e9f6e";
                e.currentTarget.style.backgroundColor = "#f3faf7";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "#e0e0e0";
                e.currentTarget.style.backgroundColor = "#fff";
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#def7ec",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#0e9f6e",
                  flexShrink: 0,
                }}
              >
                <Globe size={24} />
              </div>
              <div>
                <h4 style={{ margin: "0 0 4px 0", fontSize: "1.05rem", fontWeight: "600", color: "#333" }}>
                  {t("appointmentView.changeLanguage", "Change Language")}
                </h4>
                <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
                  {t(
                    "appointmentView.changeLanguageHint",
                    "Select a new language. Client, date, time, and other appointment details will be preserved."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BootstrapDialog>
  );
}

export default ChangeClientLanguageModal;
